<template>
  <div class="floating-sidebar">
    <!-- 侧边栏内容 -->
    <div class="sidebar-content">
      <div v-for="(item, index) in sidebarItems"
           :key="index"
           class="sidebar-item"
           @mouseover="showPopup(item.type)"
           @mouseout="hidePopup">
        <img :src="item.icon" class="sidebar-item-image" :alt="item.title"/>
        <div style="margin-top: 5px;color: #959595; font-size: 12px; ">{{ item.title }}</div>
      </div>
    </div>

    <!-- 弹出层 -->
    <transition name="fade">
      <div v-if="currentPopup === 'phone'" class="popup-container" style="top: 0">
        <div class="popup-content">
          <div class="popup-header">
            <span>电话咨询</span>
            <p style="margin-top: 10px">{{ webConfig.phone }}</p>
          </div>
          <div class="popup-body">
            <div class="mini-label">{{ webConfig.svctm }}</div>
          </div>
        </div>
      </div>

      <div v-if="currentPopup === 'QQ'" class="popup-container" style="top: 45px">
        <div class="popup-content">
          <div class="popup-header">
            <span>QQ咨询</span>
            <p style="margin-top: 10px">{{ webConfig.qq }}</p>
          </div>
          <div class="popup-body">
            <div class="mini-label">{{ webConfig.svctm }}</div>
          </div>
        </div>
      </div>

      <div v-if="currentPopup === 'weixin'" class="popup-container" style="top: 45px">
        <div class="popup-content">
          <div class="popup-header">
            <!--            <vue-qr :text="webConfig.wechat" :size="150" :margin="10"></vue-qr>-->
            <img src="@/assets/image/企微客服.png" :width="150" :margin="10"/>
          </div>
          <div class="popup-body">
            <div class="mini-label">微信客服</div>
          </div>
        </div>
      </div>

<!--      <div v-if="currentPopup === 'gonggzuo'" class="popup-container" style="top: 45px">-->
<!--        <div class="popup-content">-->
<!--          &lt;!&ndash;         <vue-qr :text="webConfig.wechatPublic" :size="150" :margin="10"></vue-qr>&ndash;&gt;-->
<!--          <img src="@/assets/image/微信小程序.jpg" :width="150" :margin="10"/>-->
<!--        </div>-->
<!--        <div class="popup-body">-->
<!--          <div class="mini-label">微信小程序</div>-->
<!--        </div>-->
<!--        <div class="popup-content">-->
<!--          &lt;!&ndash;         <vue-qr :text="webConfig.wechatPublic" :size="150" :margin="10"></vue-qr>&ndash;&gt;-->
<!--          <img src="@/assets/image/支付宝小程序.png" :width="150" :margin="10"/>-->
<!--        </div>-->
<!--        <div class="popup-body">-->
<!--          <div class="mini-label">支付宝小程序</div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="popup-container" style="top: 185px" v-if="currentPopup === 'APP'">
        <div class="popup-content">
          <vue-qr :text="webConfig.appLink" :size="150" :margin="10" v-if="webConfig.appLink"></vue-qr>
        </div>
        <div class="popup-body">
          <div class="mini-label">APP下载地址</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
import vueQr from "vue-qr";

export default {
  components: {
    vueQr,
  },
  data() {
    return {
      sidebarItems: [
        {
          type: 'phone',
          title: '电话',
          icon: require('../../assets/image/dianhua.png'),
          popupContent: '19272927776'
        },
        {
          type: 'QQ',
          title: 'QQ',
          icon: require('../../assets/image/myqq.png'),
          popupContent: '177411296'
        },
        {
          type: 'weixin',
          title: '微信',
          icon: require('../../assets/image/weixin.png'),
        },
        // {
        //   type: 'gonggzuo',
        //   title: '小程序',
        //   icon: require('../../assets/image/erweima.png'),
        // },
        {
          type: 'APP',
          title: 'APP',
          icon: require('../../assets/newImage/logos.png'),
        },
      ],
      currentPopup: '',
      webConfig: undefined
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getWebConfig();
    })
  },
  methods: {
    showPopup(type) {
      this.currentPopup = type;
    },
    hidePopup() {
      this.currentPopup = '';
    },
    getWebConfig() {
      http.get("/config/web").then((response) => {
        if (response.code === 200) {
          this.webConfig = response.data;
          this.webConfig.appLink = 'https://file.hblingdian.cn/apk/lingdian-guanwang.apk'
          localStorage.setItem('wechat', this.webConfig.wechat);
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.floating-sidebar {
  position: fixed;
  top: 300px;
  right: 0px;
  width: 55px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0px;
}

.sidebar-item {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;

  .sidebar-item-image {
    width: 35px;
    height: 35px;
  }
}

.sidebar-item:hover {
  text-decoration: underline;
}

.popup-container {
  position: absolute;
  left: -202px;
  width: 200px;
  padding: 10px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: all 0.3s ease;
}

.popup-content {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;

  .qr-img {
    height: 99px;
    width: 99px;
  }
}

.popup-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close-btn {
  cursor: pointer;
}

.popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .mini-label {
    font-size: 11px;
    //color: #0000003f;
    color: #000000;
  }

  .contract-btn {
    margin-top: 20px;
    background: #488eff;
    border-radius: 6px;
    color: #fff;
    font-size: 12px;
    width: 127px;
    height: 28px;
    line-height: 28px;
    text-align: center;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
